module.exports = __webpack_public_path__ + "media/components/icons/SVG/flag-df5ba211c1b8a3e8926dbe06a9aad58d.svg";